import { mapValues } from 'lodash';
/**
 * Version 44 migrations: adding missing syles for agenda and sessions widget
 */
export default function v44(website) {
  return {
    ...website,
    eventVersion: 44,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Agenda' && !layoutItem.config.style.speakerTitle) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            display: {
              ...layoutItem.config.display
            },
            style: {
              ...layoutItem.config.style,
              speakerModalExit: {
                styleMapping: 'custom',
                text: {
                  color: 'secondary'
                }
              }
            }
          }
        };
      }
      if (layoutItem.widgetType === 'Sessions' && !layoutItem.config.style.speakerTitle) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            display: {
              ...layoutItem.config.display
            },
            style: {
              ...layoutItem.config.style,
              speakerModalExit: {
                styleMapping: 'custom',
                text: {
                  color: 'secondary'
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
